let currentToken = null;
const getScopeCurrentToken = () => currentToken;
const setScopeCurrentToken = newToken => {
  currentToken = newToken;
};
export const getCachedCurrentToken = () => {
  return getScopeCurrentToken();
};
export const setCachedCurrentToken = newToken => {
  setScopeCurrentToken(newToken);
};
export const clearCachedCurrentToken = () => {
  setScopeCurrentToken(null);
};
//# sourceMappingURL=cache.js.map